// WEBSITE FOR HEX-COLOR_NAMES MAPPING: https://chir.ag/projects/name-that-color

export const COLORS = {
  HIGHLAND: "#65946A",
  TUNA: "#313237",
  SLATE_GRAY: "#718797",
  CASPER: "#B6C7D4",
  WHITE: "#FFFFFF",
  ATHENS_GRAY: "#EDEDF2",
};
